export class OrarioPrenotazione {

	id: number;
	dataOraDa: Date;
	dataOraA: Date;
	confermatoProprietario: boolean;
	confermatoCliente: boolean;
	
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/orario-prenotazione.ts